// extracted by mini-css-extract-plugin
module.exports = {"input-item":"Input_input-item__foTQW","input-item--disabled":"Input_input-item--disabled__3hPWt","text-label":"Input_text-label__3l5rJ","invalid":"Input_invalid__1ZOur"};